import { ButtonVariant } from '@/shared/components/Buttons';
import type { UpdateStatusDialogProps } from '@/epics/adminManagment/pages/adminList/UpdateStatusDialog';
import {
  SubscriptionPlanStatusDescription,
  SubscriptionStatusSwitchIcon,
} from './SubscriptionStatusDialogContent';

export type SubscriptionStatusDialogConfig = Pick<
  UpdateStatusDialogProps,
  | 'title'
  | 'content'
  | 'confirmButtonLabel'
  | 'confirmButtonLabelLoading'
  | 'icon'
  | 'confirmButtonVariant'
>;

export function getSubscriptionStatusDialogConfig(
  planName: string,
  isActive: boolean
): SubscriptionStatusDialogConfig {
  const isActivating = !isActive;
  return {
    title: isActivating
      ? 'Aktywować plan subskrypcji?'
      : 'Dezaktywować plan subskrypcji?',
    content: (
      <SubscriptionPlanStatusDescription
        planName={planName}
        isActivating={isActivating}
      />
    ),
    confirmButtonLabel: isActivating ? 'Aktywuj' : 'Dezaktywuj',
    confirmButtonLabelLoading: isActivating
      ? 'Aktywowanie…'
      : 'Dezaktywowanie…',
    icon: <SubscriptionStatusSwitchIcon isActivating={isActivating} />,
    confirmButtonVariant: isActivating
      ? ButtonVariant.Success
      : ButtonVariant.Error,
  };
}
